// extracted by mini-css-extract-plugin
export default {"form":"Search_form__FNfwU","search":"Search_search__od23w","button":"Search_button__3ymJv","svg":"Search_svg__EVF3M"};